export default "__VITE_ASSET__DCDu70Xx__"